import { Component } from 'react'
import * as styles from 'components/features/pfm/Overlay/OverlayMobile.css'
import { OverlayContainer } from 'components/features/pfm/Overlay/OverlayContainer'
import CloseButton from 'components/atoms/buttons/CloseButton'
import Scrollable from 'components/atoms/Scrollable'
import * as cn from 'classnames'
import { QAMarked } from 'interfaces/component'
import { QA_MARKER_OVERLAY_CLOSE_BUTTON } from 'constants/component'

export type OverlayMobileProps = QAMarked & {
  noPadding?: boolean
  isLoading?: boolean
  onClose: () => void
}

export class OverlayMobile extends Component<OverlayMobileProps> {
  render () {
    const {
      qaMarker,
      children,
      noPadding,
      isLoading,
      onClose,
    } = this.props

    const className = cn(styles.wrapper, {
      [styles.noPadding]: noPadding,
    })

    return (
      <OverlayContainer
        qaMarker={ qaMarker }
        isFullScreen
        onClose={ onClose }
      >
        <Scrollable contentClassName={ className }>
          { children }
          { !isLoading && (
            <div className={ styles.closeButtonWrapper }>
              <CloseButton
                qaMarker={ QA_MARKER_OVERLAY_CLOSE_BUTTON }
                onClick={ onClose }
              />
            </div>
          )}
        </Scrollable>
      </OverlayContainer>
    )
  }
}
